// extracted by mini-css-extract-plugin
module.exports = {"forgotPassword":"styles_forgotPassword__3-2ez"};